module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-80.d2be659d.svg";